import chills from './images/chills.svg';
import electricity from './images/electricity.svg';
import led from './images/led.svg';
import safe from './images/safe.svg';
import award from './images/award.svg';
import touch from './images/touch.svg';
import eco from './images/eco.svg';
import whisper from './images/whisper.svg';
import tank from './images/tank.svg';
import control from './images/control.svg';
import app from './images/app.svg';
import smart from './images/smart.svg';
import ultraportable from './images/ultraportable.svg';
import weight from './images/weight.svg';

export default {
  evachill: [
    {
      image: chills,
      text: 'features.chills',
    },
    {
      image: electricity,
      text: 'features.electricity1',
    },
    {
      image: ultraportable,
      text: 'features.ultraportable',
    },
    {
      image: led,
      text: 'features.led1',
    },
    {
      image: safe,
      text: 'features.safe',
    },
    {
      image: award,
      text: 'features.award2',
    },
    {
      image: eco,
      text: 'features.eco',
    },
    {
      image: touch,
      text: 'features.button',
    },
    {
      image: whisper,
      text: 'features.whisper',
    },
    {
      image: weight,
      text: 'features.weight',
    },
  ],
  evasmart: [
    {
      image: chills,
      text: 'features.chills',
    },
    {
      image: electricity,
      text: 'features.electricity3',
    },
    {
      image: led,
      text: 'features.led2',
    },
    {
      image: safe,
      text: 'features.safe',
    },
    {
      image: award,
      text: 'features.award2',
    },
    {
      image: touch,
      text: 'features.touch',
    },
    {
      image: eco,
      text: 'features.eco',
    },
    {
      image: whisper,
      text: 'features.whisper',
    },
    {
      image: tank,
      text: 'features.tank',
    },
    {
      image: control,
      text: 'features.color',
    },
    {
      image: app,
      text: 'features.app',
    },
    {
      image: smart,
      text: 'features.smart',
    },
  ],
  evalight: [
    {
      image: chills,
      text: 'features.chills',
    },
    {
      image: electricity,
      text: 'features.electricity2',
    },
    {
      image: led,
      text: 'features.led2',
    },
    {
      image: safe,
      text: 'features.safe',
    },
    {
      image: award,
      text: 'features.award1',
    },
    {
      image: eco,
      text: 'features.eco',
    },
    {
      image: touch,
      text: 'features.wheel',
    },
    {
      image: whisper,
      text: 'features.whisper',
    },
    {
      image: tank,
      text: 'features.tank',
    },
  ],
};
